var _title, _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 -2.5 64 64",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), "\r\n    {title === undefined ? (\r\n      ", title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "{titleId}"
  }, "{\"Thumb-up\"}") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "{titleId}"
  }, title) : null, "\r\n    ) : title ? (\r\n      ", _title || (_title = /*#__PURE__*/React.createElement("title", {
    id: "{titleId}"
  }, "{title}")), "\r\n    ) : null}\r\n    ", _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "{\"Created with Sketch.\"}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Thumb-up",
    transform: "translate(1.000000, 2.000000)",
    stroke: "#6B6C6E",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,20 L2.9,20 C0.1,20 0,22.1 0,24.8 L0,49.1 C0,51.7 0.1,53.9 2.9,53.9 L18,53.9 C20.8,53.9 20.9,51.8 20.9,49.1 L20.9,24.8 C20.9,22.2 20.8,20 18,20 L18,20 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7,50.3 L22.1,50.3 C25.9,50.2 28.4,56 31.3,56 L53.9,56 C56.7,56 57.3,51.8 57.2,50 C57.2,50 60.7,48.4 59.1,42 C59.3,41.9 61.1,40.2 61.1,36.9 C61.1,33.6 59.2,32 59.2,32 C59.2,32 61.1,29.9 61.1,26.8 C61.1,23.7 58.4,22 55.6,22 L47.3,22 C40.1,22 40.7,18.1 40.7,18.1 C40.7,18.1 39.9,8 37.3,3.3 C34.1,-2.5 27.7,-0.6 30.1,7 C31.9,12.6 23.8,21 20.8,23.8",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.8756a79e04d0e9b99e2301c9e080464c.svg";
export { ForwardRef as ReactComponent };